import React, { useState, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import parseObjectToQuery from '@/utils/functions/parseObjectToQuery';

import SearchInputWithSelect from '@/views/components/SearchInputWithSelect/SearchInputWithSelect';

import styles from '@/views/pages/Dictionary/Dictionary.module.scss';

const DictionarySearchFilters = ({ noRecords }) => {
	const location = useLocation();
	const navigate = useNavigate();

	const { dict } = useSelector((state) => state.app);

	const [ searchedQuery, setSearchedQuery ] = useState('');
	const [ query, setQuery ] = useState('');
	const [ selectValue, setSelectValue ] = useState({ value: 'all', label: dict.dictionary.list.options.all });

	const searchQuery = (searchString = null) => {
		const searchParams = queryString.parse(location.search);
		const copiedSearchParams = Object.assign({}, searchParams);
		if (searchString === null || searchString.length === 0) {
			if (Object.keys(copiedSearchParams).indexOf('q') !== -1) {
				delete copiedSearchParams.q;
				if (copiedSearchParams.ord === '-accuracy') { copiedSearchParams.ord = 'inputPhrase'; }
				navigate(`${location.pathname}?${parseObjectToQuery(copiedSearchParams)}`);
			}
		} else {
			delete copiedSearchParams.ord;
			navigate(`${location.pathname}?q=${encodeURIComponent(searchString)}&ord=-accuracy&page=1`);
		}
	};

	const switchSelectInURL = (newValue) => {
		const urlObj = Object.fromEntries(new URLSearchParams(location.search));

		if (newValue === 'all') {
			urlObj['inInputPhrase'] = 'true';
			urlObj['inOutputPhrase'] = 'true';
		} else if (newValue === 'only-original') {
			urlObj['inInputPhrase'] = 'true';
			urlObj['inOutputPhrase'] = 'false';
		} else if (newValue === 'only-simplified') {
			urlObj['inInputPhrase'] = 'false';
			urlObj['inOutputPhrase'] = 'true';
		}

		navigate(`${location.pathname}?${new URLSearchParams(urlObj).toString()}`);
	};

	useEffect(() => {
		const urlObj = Object.fromEntries(new URLSearchParams(location.search));
		if (urlObj.q) {
			setQuery(urlObj.q);
			setSearchedQuery(urlObj.q);
		}
		if (urlObj.inInputPhrase && urlObj.inInputPhrase.toString() === 'true' && urlObj.inOutputPhrase && urlObj.inOutputPhrase.toString() === 'false') {
			setSelectValue({ value: 'only-original', label: dict.dictionary.list.options.onlyOriginal });
		} else if (urlObj.inInputPhrase && urlObj.inInputPhrase.toString() === 'false' && urlObj.inOutputPhrase && urlObj.inOutputPhrase.toString() === 'true') {
			setSelectValue({ value: 'only-simplified', label: dict.dictionary.list.options.onlySimplified });
		}
	}, [ location.search ]);

	useEffect(() => {
		const searchParams = queryString.parse(location.search);
		const copiedSearchParams = Object.assign({}, searchParams);
		if (copiedSearchParams.q) {
			setQuery(copiedSearchParams.q);
			setSearchedQuery(copiedSearchParams.q);
		} else {
			setQuery("");
			setSearchedQuery("");
		}
	}, [ location ]);

	return (
		<section className={ styles['dictionary__searchbar'] }>
			<div className={ styles['dictionary__searchbar--item'] }>
				<SearchInputWithSelect
					label={ dict.dictionary.list.searchLabel }
					placeholder={ "" }
					searchedValue={ searchedQuery }
					value={ query }
					setValue={ setQuery }
					searchFunction={ searchQuery }
					options = { [
						{ value: 'all', label: dict.dictionary.list.options.all },
						{ value: 'only-original', label: dict.dictionary.list.options.onlyOriginal },
						{ value: 'only-simplified', label: dict.dictionary.list.options.onlySimplified },
					] }
					selectValue={ selectValue }
					onSelectChange={ (val) => { setSelectValue(val); switchSelectInURL(val.value); } }
					disabled={ noRecords }
				/>
			</div>
		</section>
	);
};

export default memo(DictionarySearchFilters);